import { create } from 'zustand';
import { isFunction } from 'lodash';
import { TeamRow } from 'wb-reddit/app/routes/teams/container';

type RedditTeamMutationStorage = {
	mutatingTeam?: TeamRow,
	setMutatingTeam: (user: undefined | TeamRow | ((curr: TeamRow | undefined) => TeamRow | undefined)) => void
};

// TODO check mutation function, executes multiple times when open edit page
const useRedditTeamMutationStore = create<RedditTeamMutationStorage>((set) => ({
	mutatingTeam:    undefined,
	setMutatingTeam: team => {
		set(curr => ({
			mutatingTeam: isFunction(team) ? team(curr.mutatingTeam) : team,
		}));
	},
}));

export default useRedditTeamMutationStore;
